import React, { Fragment, useContext } from 'react';
import LocaleContext from 'constants/localization';
import EditResourceDisplay from 'field/edit/resource/EditResourceDisplay';
import { resToJsonHandleErrors, actionError } from 'helpers/actionHelpers';
import API from 'constants/api';

export default function EditLinkedResources({ onEdit, onRemove, values }) {
  const LS = useContext(LocaleContext);
  const handleEdit = (index, value) => {
    // Open tab to editObject if ArchivedObject
    if (value.isArchivedObject) {
      checkAccessRightsAndRedirect(value.uri);
      return;
    }
    onEdit(index, value);
  };

  // SPEC-539
  const checkAccessRightsAndRedirect = uri => {
	fetch(`${API.ACCESSRIGHTS}?uri=${uri}&rightType=write`)
	  .then(resToJsonHandleErrors)
	  .then(json => {
	     if(json.hasAccessRights){
	       window.open(`${API.DAM.INDEX}?main_action=${API.DAM.EDIT_OBJECT}?uri=${uri}`, '_blank');
	     }else{
	       actionError({ message: 'accessDenied' });
	     }
	 });
  };
  
  return (
    <Fragment>
      {
        values.map((value, index) => {
          return (
            <div key={index} className={'edit-resource field shaded'}>
              <EditResourceDisplay value={value} />
              {
                onEdit &&
                <button className="action-link" 
                  type="button"
                  index={index}
                  onClick={() => handleEdit(index, value)}>
                  {LS.actions.edit}
                </button>
              }
              {
                onRemove && 
                <button className="action-link" 
                  type="button" 
                  index={index} 
                  onClick={() => onRemove(index, value)}>
                  {LS.actions.remove}
                </button>
              }  
            </div>
          );
        })
      }
    </Fragment>
  );
}